import React      from "react";
import List       from "../components/list";
import ListItem   from "../components/list-item";
import Spinner    from "../components/spinner";
import View       from "./view";
import messages   from "../../../messages";
import config     from "../../../config";
import Clinic     from "../components/clinic"

export default class StartView extends View {
    static get title() {
        return "выберите вариант записи";
    }

    static get titleShort() {
        return "";
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            service: React.PropTypes.string,
            doctor: React.PropTypes.string,
        });
    }

    constructor (props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: [
                {
                    name: 'Услуги',
                    id: 1,
                    nextView: 'ServiceView',
                },
                {
                    name: 'Специалисты',
                    id: 2,
                    nextView: 'DoctorView',
                },
                // {
                //     name: 'Направления',
                //     id: 3,
                //     nextView: 'TagsView',
                // },
            ]
        });

        this._isMounted = false;
    }



    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
    }

    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner />;
        }
        let nextView = "TagsView";
        let viewProps = {};

        if (!!this.props.doctor) {
            viewProps = {doctor : this.props.doctor} ;
        }
        if (!!this.props.service) {
            nextView = "DoctorView";
            viewProps = {service : this.props.service} ;
        }
        if (!!this.props.tag) {
            nextView = "ServiceView";
            viewProps = {tag : this.props.tag} ;
        }

        const elements = this.state.items.map((item, key) => {
            return (
                <ListItem key={key} isActive={true} onClick={() => {
                    this.props.gotoNextView({
                        breadcrumbName: item.name.toLowerCase(),
                        nextView: item.nextView,
                        props: {
                            ...viewProps,
                        }
                    });
                }}>
                    <Clinic
                        name={item.name}
                        address={item.address}
                        />
                </ListItem>
            );
        });

        return <List>{elements}</List>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--specialization">
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/start.js
 **/